module.exports = __webpack_public_path__ + "static/media/배너 목록.2d620d19.jpg";